import styles from './TemplateInfoButtons.module.css';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { CartIcon } from '@shared/Icons/CartIcon';
import { TEMPLATE_PRICE } from '@shared/Constants/TemplatePrice';
import EyeIcon from '@shared/Icons/EyeIcon';
import React from 'react';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';

interface Props {
    onBuyTemplate: () => void;
    isLoading?: boolean;
    // onViewProjectExample: () => void;
}

export const TemplateInfoButtons: React.FC<Props> = ({
    onBuyTemplate,
    isLoading = false,
    // onViewProjectExample,
}) => {
    const { currentTemplate } = useTemplatesViewModel();
    return (
        <section className={styles.btns}>
            <BasicButton
                onClick={onBuyTemplate}
                extraClassName={styles.buyBtn}
                isLoading={isLoading}
            >
                <div className={styles.btnContent}>
                    <CartIcon fill="currentColor" />
                    {currentTemplate?.paid
                        ? `BUY FOR R ${TEMPLATE_PRICE}`
                        : 'GET FOR FREE'}
                </div>
            </BasicButton>
            {/*<BasicButton*/}
            {/*    onClick={onViewProjectExample}*/}
            {/*    extraClassName={styles.viewBtn}*/}
            {/*    isReversed={true}*/}
            {/*>*/}
            {/*    <div className={styles.btnContent}>*/}
            {/*        <EyeIcon fill="currentColor" />*/}
            {/*        EXAMPLE PAVING BOM*/}
            {/*    </div>*/}
            {/*</BasicButton>*/}
        </section>
    );
};
